import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    image: data?.image,
    name_en:
      data?.localized_data?.en?.name ||
      data?.localized_data?.name_en ||
      data?.name_en ||
      data?.name ||
      "",
    name_ar:
      data?.localized_data?.ar?.name ||
      data?.localized_data?.name_ar ||
      data?.name_ar ||
      "",
    display_priority: data?.display_priority ?? "",
    is_active: data?.is_active ?? true,
  };
};

export const structure = (_, __, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: `${t("common.image")}*`,
        width: "100%",
      },
      {
        name: `name_en`,
        kind: "input",
        type: "text",
        label: `${t("events_event_types.name_en")}*`,
        width: "47%",
      },
      {
        name: `name_ar`,
        kind: "input",
        type: "text",
        label: `${t("events_event_types.name_ar")}*`,
        width: "47%",
      },
      {
        name: `display_priority`,
        kind: "input",
        type: "number",
        label: t("events_event_types.display_priority"),
        width: "47%",
      },
      {
        name: `is_active`,
        kind: "checkbox",
        type: "text",
        label: t("events_event_types.is_active"),
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    name_en: Yup.string().required("Required"),
    name_ar: Yup.string().required("Required"),
    image: Yup.mixed().required("Required"),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
  });
